<template>
  <!-- Trial or subscription state of a client on the super admin pages (US 9436) -->
  <span v-if="state"
        class="v2-tag"
        :class="state.tag"
        v-b-tooltip.hover
        :title="state.title"
        qid="client-trial-pill"
  >{{ state.label }}</span>
</template>

<script>
import {config} from '@/config.js';

const moment = require('moment');

// Days before the end that a running trial turns amber, as on the overview
const WARNING_DAYS = 14;

export default {
  name: 'TrialPill',
  props: {
    client: Object
  },
  computed: {
    state() {
      let client = this.client || {};
      if (client.paying) {
        return { tag: 'v2-tag--teal', label: this.$t('admin_page.trial.paying'), title: null };
      }
      if (!client.trial_ends_at) {
        return null;
      }
      let ends = moment(client.trial_ends_at);
      let title = this.$t('admin_page.trial.ends_on', { date: this.$options.filters.formatDate(client.trial_ends_at, config.dateFormat) });
      if (ends.isBefore(moment())) {
        return { tag: 'v2-tag--red', label: this.$t('admin_page.trial.ended'), title: title };
      }
      let days = Math.max(ends.diff(moment().startOf('day'), 'days'), 0);
      return {
        tag: days <= WARNING_DAYS ? 'v2-tag--amber' : 'v2-tag--blue',
        label: this.$tc('admin_page.trial.ends_in', days, { count: days }),
        title: title
      };
    }
  }
}
</script>
